import { Fragrance } from "./v1";

export type FragranceV1Type = keyof typeof Fragrance;
export type FragranceType = FragranceV1Type;
